export const CHAT_REF = 'chat/last-read';

export default function (_this) {
  return {
    async save(id, data) {
      const snapshot = await getRef(id).once('value');
      const userValue = snapshot.exists() ? snapshot.val() : {};
      const lastRead = { ...userValue, ...data };
      await getRef(id).set(lastRead);
    },
    async get(id) {
      return (await getRef(id).once('value')).val();
    },
    getRef
  }

  function getRef(id) {
    return _this.getRef(`${CHAT_REF}/${id}`);
  }
}
